export const enumPermisosBancoW = Object.freeze({
  RETIRO_BANCO_W: 60002,
  PAGO_PRODUCTOS_PROPIOS_BANCO_W: 60003,
});

export const enumTiposOperacionesBancoW = Object.freeze({
  RETIRO_BANCO_W: 206,
  PAGO_PRODUCTOS_PROPIOS_BANCO_W: 207,
});